import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { CarFront, X } from 'lucide-react'
import { tr } from 'i18n'
import VehicleNumberInput from 'components/Forms/VehicleNumberInput/VehicleNumberInput.tsx'
import s from 'pages/AdminPanelPage/Management.module.scss'
import './RequestVehicleCorrection.scss'

type Props = {
  id: number
  plate: string
  model: string
  error: string
  busy: boolean
  onPlate: (value: string) => void
  onModel: (value: string) => void
  onSave: () => void
  onClose: () => void
  children: ReactNode
}

export default function RequestVehicleCorrection({ id, plate, model, error, busy, onPlate, onModel, onSave, onClose, children }: Props) {
  useTranslation()
  return <div className={s.overlay}>
    <form className={`${s.dialog} request-vehicle-correction`} role="dialog" aria-modal="true" aria-labelledby="request-correct-title"
      onSubmit={event => { event.preventDefault(); onSave() }}>
      <h2 id="request-correct-title"><CarFront size={20} aria-hidden="true" />{tr('Номер автомобиля · заявка #')}{id}</h2>
      {error && <div className={s.error} role="alert">{tr(error)}</div>}
      <p className={s.muted}>{tr('Сверьте номер с фотографией автомобиля и техпаспортом.')}</p>
      {children}
      <label className={s.field}>{tr('Номер автомобиля')}<VehicleNumberInput required value={plate} onChange={event => onPlate(event.target.value.toUpperCase())} /></label>
      <label className={s.field}>{tr('Модель автомобиля')}<input value={model} onChange={event => onModel(event.target.value)} /></label>
      <div className={s.footer}>
        <button type="button" className={s.button} disabled={busy} onClick={onClose}><X size={14} aria-hidden="true" />{tr('Отмена')}</button>
        <button className={s.primary} disabled={busy || !plate}>{tr('Сохранить исправление')}</button>
      </div>
    </form>
  </div>
}
